import PropTypes from "prop-types";
import { Drawer, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const RightDrawer = ({ open, onClose, title, children, width = 480 }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          width,
          maxWidth: "100%",
          padding: "24px 24px 32px",
          borderRadius: "16px 0 0 16px"
        }
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: "#101828" }}>{title}</h3>
        <IconButton aria-label="close drawer" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </div>
      <div style={{ maxHeight: "calc(100vh - 120px)", overflowY: "auto" }}>
        {children}
      </div>
    </Drawer>
  );
};

RightDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  width: PropTypes.number
};

export default RightDrawer;
